import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "rag";
const ragActionNameGenerator = actionNameGenerator(domainPrefix);

export const fetchRecentGrantType = ragActionNameGenerator("fetchRecentGrant");
export const postCharitySearchType = ragActionNameGenerator(
  "postCharitySearch"
);
export const postCitySearchType = ragActionNameGenerator("postCitySearch");
export const postCountrySearchType = ragActionNameGenerator(
  "postCountrySearch"
);
export const cityLoaderType = ragActionNameGenerator("cityLoader");
export const countryLoaderType = ragActionNameGenerator("countryLoader");
export const selectCharityType = ragActionNameGenerator("selectCharity");
export const changeScheduleAllocationType = ragActionNameGenerator(
  "changeScheduleAllocation"
);
export const changeNumberOfPaymentsType = ragActionNameGenerator(
  "changeNumberOfPayments"
);
export const geminiFilterType = ragActionNameGenerator("geminiFilter");
export const updateFromCounterType = ragActionNameGenerator(
  "updateFromCounter"
);
export const updateFromLoadingCounterType = ragActionNameGenerator(
  "updateFromLoadingCounter"
);
export const clearPaymentDetailsType = ragActionNameGenerator(
  "clearPaymentDetails"
);
export const receiveAllocationDataType = ragActionNameGenerator(
  "receiveAllocationData"
);
export const fetchGrantHistoryType = ragActionNameGenerator(
  "fetchGrantHistory"
);
export const fetchPendingGrantType = ragActionNameGenerator(
  "fetchPendingGrantType"
);
export const updateFromType = ragActionNameGenerator("updateFrom");
export const einDataType = ragActionNameGenerator("einData");
export const geminiEinDataType = ragActionNameGenerator("geminiEinData");
export const searchTermType = ragActionNameGenerator("searchTerm");
export const geminiSearchTermType = ragActionNameGenerator("geminiSearchTerm");
export const searchGeminiType = ragActionNameGenerator("searchGemini");
export const fetchGrantPurposeType = ragActionNameGenerator(
  "fetchGrantPurpose"
);
export const changePurposeRecognitionType = ragActionNameGenerator(
  "changePurposeRecognition"
);
export const removeCharityType = ragActionNameGenerator("removeCharity");
export const fetchSavedCharityType = ragActionNameGenerator(
  "fetchSavedCharity"
);
export const saveCharityType = ragActionNameGenerator("saveCharity");
export const postGeminiSavedDataType = ragActionNameGenerator(
  "postGeminiSavedData"
);
export const submitGrantType = ragActionNameGenerator("submitGrant");
export const cancelFlowType = ragActionNameGenerator("cancelFlow");
export const grantDetailsLoaderType = ragActionNameGenerator(
  "grantDetailsLoader"
);
export const enableEditType = ragActionNameGenerator("enableEdit");
export const resetEditType = ragActionNameGenerator("resetEdit");
export const updateGrantType = ragActionNameGenerator("updateGrant");
export const updateClearErrorsType = ragActionNameGenerator(
  "updateClearErrors"
);
export const needUpdateType = ragActionNameGenerator("needUpdate");
export const scheduleIdType = ragActionNameGenerator("scheduleId");
export const cancelScheduleType = ragActionNameGenerator("cancelSchedule");
export const cancelAllSchedulesType = ragActionNameGenerator(
  "cancelAllSchedules"
);
export const addSpawnType = ragActionNameGenerator("addSpawn");
export const updateIndividualSpawnType = ragActionNameGenerator("updateIndividualSpawn");
export const newFlowType = ragActionNameGenerator("newFlow");
export const reGrantType = ragActionNameGenerator("reGrant");
export const clearAllFilterType = ragActionNameGenerator("clearAllFilter");
export const clearAllGeminiFilterType = ragActionNameGenerator(
  "clearAllGeminiFilter"
);
export const poolsPendingAdminFeeType = ragActionNameGenerator(
  "poolsPendingAdminFee"
);
export const addCharityType = ragActionNameGenerator("addCharity");
export const cancelSaveCharityType = ragActionNameGenerator(
  "cancelSaveCharity"
);
export const exhaustCheckType = ragActionNameGenerator("exhaustCheck");
export const pageScrollType = ragActionNameGenerator("pageScroll");
export const addProjectNameType = ragActionNameGenerator("addProjectName");
export const addPurposeType = ragActionNameGenerator("addPurpose");
export const addEventNameType = ragActionNameGenerator("addEventName");
export const addMissionaryNameType = ragActionNameGenerator(
  "addMissionaryName"
);
export const addMissionaryLocationType = ragActionNameGenerator(
  "addMissionaryLocation"
);
export const savedCharityFlagType = ragActionNameGenerator("savedCharityFlag");

/** For Saga use */

export const searchCharityResponseType = ragActionNameGenerator(
  "searchCharityResponse"
);

export const searchGeminiResponseType = ragActionNameGenerator(
  "searchGeminiResponse"
);

export const searchCharityDataLengthType = ragActionNameGenerator(
  "searchCharityDataLength"
);

export const searchCharityErrorResponseType = ragActionNameGenerator(
  "searchCharityErrorResponse"
);

export const searchGeminiErrorType = ragActionNameGenerator(
  "searchGeminiError"
);

export const searchCityResponseType = ragActionNameGenerator(
  "searchCityResponse"
);

export const searchCityErrorType = ragActionNameGenerator("searchCityError");

export const searchCountrySuccessResponseType = ragActionNameGenerator(
  "searchCountrySuccessResponse"
);

export const searchCountryErrorResponseType = ragActionNameGenerator(
  "searchCountryErrorResponse"
);

export const fetchAllocationDataLoadingType = ragActionNameGenerator(
  "fetchAllocationDataLoading"
);

export const fetchAllocationDataSuccessType = ragActionNameGenerator(
  "fetchAllocationDataSuccess"
);

export const fetchAllocationDataFailType = ragActionNameGenerator(
  "fetchAllocationDataFail"
);

export const fetchAllocationDataDoneType = ragActionNameGenerator(
  "fetchAllocationDataDone"
);

export const updateFromCounterWorkerType = ragActionNameGenerator(
  "updateFromCounterWorker"
);

export const updateFromLoadMoreCounterWorkerType = ragActionNameGenerator(
  "updateFromLoadMoreCounterWorker"
);

export const fetchRecentGrantSuccessType = ragActionNameGenerator(
  "fetchRecentGrantSuccess"
);

export const fetchRecentGrantFailType = ragActionNameGenerator(
  "fetchRecentGrantFail"
);

export const fetchGrantHistorySuccessType = ragActionNameGenerator(
  "fetchGrantHistorySuccess"
);

export const fetchGrantHistoryFailType = ragActionNameGenerator(
  "fetchGrantHistoryFail"
);

export const cancelScheduleSuccessType = ragActionNameGenerator(
  "cancelScheduleSuccess"
);

export const cancelScheduleFailType = ragActionNameGenerator(
  "cancelScheduleFail"
);

export const cancelAllScheduleSuccessType = ragActionNameGenerator(
  "cancelAllScheduleSuccess"
);

export const cancelAllScheduleFailType = ragActionNameGenerator(
  "cancelAllScheduleFail"
);

export const updateSpawnSuccessType = ragActionNameGenerator(
  "updateSpawnSuccess"
);

export const updateSpawnFailType = ragActionNameGenerator(
  "updateSpawnFail"
);

export const addSpawnSuccessType = ragActionNameGenerator(
  "addSpawnSuccess"
);

export const addSpawnFailType = ragActionNameGenerator(
  "addSpawnFail"
);

export const fetchGrantDetailSuccessType = ragActionNameGenerator(
  "fetchGrantDetailSuccess"
);

export const fetchGrantDetailFalType = ragActionNameGenerator(
  "fetchGrantDetailFal"
);

export const fetchPendingGrantSuccessType = ragActionNameGenerator(
  "fetchPendingGrantSuccess"
);

export const fetchPendingGrantFailType = ragActionNameGenerator(
  "fetchPendingGrantFail"
);

export const fetchGrantPurposeSuccessType = ragActionNameGenerator(
  "fetchGrantPurposeSuccess"
);

export const fetchGrantPurposeFailType = ragActionNameGenerator(
  "fetchGrantPurposeFail"
);

export const removeCharitySuccessType = ragActionNameGenerator(
  "removeCharitySuccess"
);

export const removeCharityFailType = ragActionNameGenerator(
  "removeCharityFail"
);

export const updateGrantSuccessType = ragActionNameGenerator(
  "updateGrantSuccess"
);

export const updateGrantFailType = ragActionNameGenerator(
  "updateGrantFail"
);

export const saveCharitySuccessType = ragActionNameGenerator(
  "saveCharitySuccess"
);

export const saveCharityFailType = ragActionNameGenerator(
  "saveCharityFail"
);

export const addCharitySuccessType = ragActionNameGenerator(
  "addCharitySuccess"
);

export const addCharityFailType = ragActionNameGenerator(
  "addCharityFail"
);

export const submitSavedGeminiDataSuccessType = ragActionNameGenerator(
  "submitSavedGeminiDataSuccess"
);

export const submitSavedGeminiDataFailType = ragActionNameGenerator(
  "submitSavedGeminiDataFail"
);

export const fetchPoolsPendingContributionSuccessType = ragActionNameGenerator(
  "fetchPoolsPendingContributionSuccess"
);

export const fetchAdminFeeSuccessType = ragActionNameGenerator(
  "fetchAdminFeeSuccess"
);

export const fetchPoolsPendingAdminFeeSuccessType = ragActionNameGenerator(
  "fetchPoolsPendingAdminFeeSuccess"
);

export const fetchPoolsPendingAdminFeeFailType = ragActionNameGenerator(
  "fetchPoolsPendingAdminFeeFail"
);

export const submitGrantSuccessType = ragActionNameGenerator(
  "submitGrantSuccess"
);

export const submitGrantFailType = ragActionNameGenerator(
  "submitGrantFail"
);

export const fetchSavedCharitySuccessType = ragActionNameGenerator(
  "fetchSavedCharitySuccess"
);

export const fetchSavedCharityFailType = ragActionNameGenerator(
  "fetchSavedCharityFail"
);